import { getLanguage } from '../getLanguage.client.js';
import { setLanguageTag, availableLanguageTags } from '$paraglide/runtime.js';
import { Navigation } from '../navigation/navigation.client.js';
import { createExclude } from '../exclude.js';
import { Middleware } from '../middleware/index.js';
import { resolveUserPathDefinitions } from '../../../../paraglide-js/dist/adapter-utils/index.js';
import { PrefixStrategy } from '../routing-strategy/strats/prefixStrategy.js';

function createI18n(userConfig = {}) {
    setLanguageTag(getLanguage);
    const config = {
        exclude: createExclude(userConfig.exclude ?? []),
        pathnames: resolveUserPathDefinitions(userConfig.pathnames ?? {}, availableLanguageTags),
        prefix: userConfig.prefix ?? "except-default",
    };
    const strategy = PrefixStrategy({
        exclude: config.exclude,
        pathnames: userConfig.pathnames || {},
        prefixDefault: config.prefix === "except-default" ? "never" : "always",
    });
    const navigation = Navigation({ strategy });
    const middleware = Middleware({ strategy });
    return {
        localizePath: (canonicalPath, lang) => {
            return strategy.getLocalisedUrl(canonicalPath, lang, getLanguage() !== lang).pathname;
        },
        getLocalisedUrl: strategy.getLocalisedUrl,
        middleware,
        ...navigation,
    };
}

export { createI18n };
